// Hình dạng doc save (TECH_BASELINE §7.1).
import type { FlagValue } from '@data/flags';

/**
 * Phiên bản schema hiện tại. Bump = BẮT BUỘC thêm MIGRATIONS[v_cũ] + fixture
 * tests/fixtures/save/v<mới>.json + test (Bất biến 8).
 * v3 (M1): thêm `core.cultivation` (tu luyện) và `core.story` (mở đầu, Điển Tịch).
 * v4 (M2): thêm `core.inventory`, `core.trial`, `core.cave`; tu luyện thêm Lịch Luyện, đan độc.
 */
export const SAVE_VERSION = 4;

/** Sổ cờ trạng thái và sổ `claimed` của grantReward, luôn nằm trong `core` (từ v2). */
export interface SaveLedger {
  flags: Record<string, FlagValue>;
  claimed: string[];
}

export interface SaveDoc {
  v: number;
  createdAt: number;
  savedAt: number;
  /** Seed gốc của thế giới (uint32). */
  seed: number;
  /** SaveSlice scope 'core': dữ liệu game. */
  core: Record<string, unknown> & { ledger: SaveLedger };
  /** SaveSlice scope 'device': tùy chọn của máy (tab đang mở, rail, trợ năng). */
  device: Record<string, unknown>;
}

export type RawDoc = Record<string, unknown>;

export function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}

export function emptyLedger(): SaveLedger {
  return { flags: {}, claimed: [] };
}

export function freshDoc(now: number, seed: number): SaveDoc {
  return {
    v: SAVE_VERSION,
    createdAt: now,
    savedAt: now,
    seed: seed >>> 0,
    core: { ledger: emptyLedger() },
    device: {},
  };
}
